import { render, staticRenderFns } from "./documentTypeCategory.vue?vue&type=template&id=d70efc62&"
import script from "./documentTypeCategory.vue?vue&type=script&lang=js&"
export * from "./documentTypeCategory.vue?vue&type=script&lang=js&"
import style0 from "./documentTypeCategory.vue?vue&type=style&index=0&id=d70efc62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports